module.exports = __webpack_public_path__ + "media/newstyle/images/stars_4-red-7c7d83971f5c1e788a4ba35022ce9720.svg";